export const getResultsData = (gameId) => ({ resultsData }) => {
	return resultsData[gameId];
}

export const getWholeResultsData = ({ resultsData }) => {
	return resultsData;
}

export const getTeamsData = ({ teamsData }) => {
	return teamsData;
}

export const getIsLoading = ({ isLoading }) => {
	return isLoading;
}
